import { ErrorPayLoad } from "../interfaces/auth"
import { Types } from "../types"
import { CheckExistEmailByCustomerIdError, CheckExistEmailByCustomerIdRequest, CheckExistEmailByCustomerIdSuccess, SetNewPasswordError, SetNewPasswordRequest, SetNewPasswordSuccess } from "../types/Auth/actionTypes"
import { CheckExistEmailByCustomerIdPayload, CheckExistEmailByCustomerIdResponse, SetNewPasswordRequestPayload } from "../types/Auth/authApiRequestType"



export const SetNewPasswordRequestAction = (payload: SetNewPasswordRequestPayload): SetNewPasswordRequest => ({
    type: Types.SET_NEW_PASSWORD_REQUEST,
    payload
})

export const SetNewPasswordSuccessAction = (): SetNewPasswordSuccess => ({
    type: Types.SET_NEW_PASSWORD_SUCCESS,
})

export const SetNewPasswordErrorAction = (payload: ErrorPayLoad): SetNewPasswordError => ({
    type: Types.SET_NEW_PASSWORD_ERROR,
    payload
})



export const checkExistEmailByCustomerIdRequestAction = (payload: CheckExistEmailByCustomerIdPayload): CheckExistEmailByCustomerIdRequest => ({
    type: Types.CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_REQUEST,
    payload
})

export const CheckExistEmailByCustomerIdSuccessAction = (response: CheckExistEmailByCustomerIdResponse): CheckExistEmailByCustomerIdSuccess => ({
    type: Types.CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_SUCCESS,
    response
})

export const CheckExistEmailByCustomerIdErrorAction = (payload: ErrorPayLoad): CheckExistEmailByCustomerIdError => ({
    type: Types.CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_ERROR,
    payload
})